import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Invoice} from '../core/_models'
import clsx from 'clsx'
import {useQueryResponse} from '../core/QueryResponseProvider'
import {InvoiceForm} from './InvoiceForm'
import {InvoiceTypeSelect} from '../InvoiceTypeSelect'
import {useListView} from '../core/ListViewProvider'
import {InvoiceSimpleFormBody} from '../invoiceSimpleForm/InvoiceSimpleFormBody'
import {InvoiceAdvancedCostFormBody} from '../invoiceAdvancedCostForm/InvoiceAdvancedCostFormBody'
import {resolveEditFormType} from '../invoiceAdvancedCostForm/advancedCostFormPolicy'
import {isAPP} from '../../../../../../_metronic/helpers'
import {CostFormServiceGate} from './CostFormServiceGate'

type Props = {
  invoice: Invoice | null | undefined
  title: {
    title: string
    setTitle: Dispatch<SetStateAction<string>>
  }
  invoiceType: {
    invoiceType: number
    setInvoiceType: Dispatch<SetStateAction<number>>
  }
  invoiceTemplate: {
    invoiceTemplate: number
    setInvoiceTemplate: Dispatch<SetStateAction<number>>
  }
  closeFn?: () => void
  formType: {
    formType: number
    setFormType: Dispatch<SetStateAction<number>>
  }
}

const InvoiceEditModalForm: FC<Props> = ({
  invoice,
  title,
  invoiceType,
  invoiceTemplate,
  closeFn,
  formType,
}) => {
  const {itemIdForUpdate, variableD} = useListView()
  const {refetch} = useQueryResponse()
  // The modal already chose the form; this keeps the advanced form off an invoice it may not edit.
  const effectiveFormType = resolveEditFormType(formType.formType, invoice, variableD)

  useEffect(() => {
    if (invoice) {
      invoiceType.setInvoiceType(invoice.typi || 1)
    }
  }, [])

  return (
    <>
      <div className='fv-row'>
        {itemIdForUpdate == null && invoiceType.invoiceType == 0 ? (
          <InvoiceTypeSelect
            title={title}
            invoiceType={invoiceType}
            invoiceTemplate={invoiceTemplate}
          />
        ) : (
          <>
            {effectiveFormType === 3 ? (
              <CostFormServiceGate formType={3} onUseFullForm={() => formType.setFormType(0)}>
                <InvoiceAdvancedCostFormBody
                  title={title}
                  invoiceType={invoiceType.invoiceType}
                  invoiceTemplate={invoiceTemplate.invoiceTemplate}
                  invoice={invoice}
                />
              </CostFormServiceGate>
            ) : effectiveFormType === 1 || effectiveFormType === 2 ? (
              <CostFormServiceGate formType={effectiveFormType} onUseFullForm={() => formType.setFormType(0)}>
                <InvoiceSimpleFormBody
                  title={title}
                  invoiceType={invoiceType.invoiceType}
                  invoiceTemplate={invoiceTemplate.invoiceTemplate}
                  invoice={invoice}
                  //closeFn={closeFn}
                  formType={effectiveFormType}
                />
              </CostFormServiceGate>
            ) : (
              <InvoiceForm
                invoiceType={invoiceType.invoiceType}
                invoiceTemplate={invoiceTemplate.invoiceTemplate}
                title={title}
                invoice={invoice}
                closeFn={closeFn}
                formType={effectiveFormType}
              />
            )}
          </>
        )}
      </div>
    </>
  )
}

export {InvoiceEditModalForm}
